<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item :label="$t('姓名')" prop="realName"  >
        <a-input v-model="form.mobile" :placeholder="$t('请输入')+$t('姓名')" :disabled="true"/>
      </a-form-model-item>
      <a-form-model-item :label="$t('联系电话')" prop="mobile"  >
        <a-input v-model="form.mobile" :placeholder="$t('请输入')+$t('联系电话')" :disabled="true"/>
      </a-form-model-item>
      <a-form-model-item :label="$t('广告名称')" prop="advertName" >
        <a-input v-model="form.advertName" :placeholder="$t('请输入')+$t('广告名称')" :disabled="true" />
      </a-form-model-item>
      <a-form-model-item :label="$t('广告简介')" prop="describe" >
        <a-input v-model="form.describe" type="textarea" :placeholder="$t('请输入')+$t('广告简介')" :disabled="true" />
      </a-form-model-item>
      <a-form-model-item :label="$t('广告活动开始时间')" prop="startTime" >
        <a-date-picker style="width: 100%" v-model="form.startTime" valueFormat="YYYY-MM-DD HH:mm:ss" :disabled="true" allow-clear/>
      </a-form-model-item>
      <a-form-model-item :label="$t('广告活动结束时间')" prop="endTime" >
        <a-date-picker style="width: 100%" v-model="form.endTime" valueFormat="YYYY-MM-DD HH:mm:ss" :disabled="true" allow-clear/>
      </a-form-model-item>
      <a-form-model-item :label="this.$t('是否通过')" prop="isPass" >
        <a-radio-group v-model="form.isPass" button-style="solid">
          <a-radio-button v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item v-if="!form.isPass" :label="this.$t('原因')" prop="failReason" >
        <a-input v-model="form.failReason" type="textarea" :placeholder="$t('请输入')+$t('原因')"  />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {getAdvertisement, addAdvertisement, auditAdvertisement} from '@/api/advert/apply'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      // 表单参数
      form: {
        id: null,
        userId: null,
        mobile: null,
        isPass: false,
        advertName: null,
        describe: null,
        startTime: null,
        endTime: null,
        status: 0,
        failReason: null,
        examineName: null,
        examineTime: null,
        createTime: null,
        localeFieldMap:{},
        remark: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        mobile: [
          { required: true, message: this.$t('联系电话')+this.$t('不能为空'), trigger: 'blur' }
        ],
        advertName: [
          { required: true, message: this.$t('广告名称')+this.$t('不能为空'), trigger: 'blur' }
        ],
        describe: [
          { required: true, message: this.$t('广告简介')+this.$t('不能为空'), trigger: 'blur' }
        ],
        startTime: [
          { required: true, message: this.$t('广告活动开始时间')+this.$t('不能为空'), trigger: 'blur' }
        ],
        endTime: [
          { required: true, message: this.$t('广告活动结束时间')+this.$t('不能为空'), trigger: 'blur' }
        ],
        isPass: [
          { required: true, message: this.$t('是否通过')+this.$t('不能为空'), trigger: 'blur' }
        ],
        failReason: [
          { required: true, message: this.$t('原因')+this.$t('不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        mobile: null,
        isPass: false,
        advertName: null,
        describe: null,
        startTime: null,
        endTime: null,
        status: 0,
        failReason: null,
        examineName: null,
        examineTime: null,
        createTime: null,
        localeFieldMap:{},
        remark: null,
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getAdvertisement({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            auditAdvertisement(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
